import calculatorStore from "../../stores/CalculatorStore";

const AddArmy = ({side}) => (
		<div className="add_army">
			<button onClick={() => calculatorStore.addArmy(side)}><i className="add_btn"/> Add {side} </button>
		</div>
)

export default AddArmy;